// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { Box } from "@mui/material";
// import photo1 from "../../../Images/TeamPhoto/photo1.webp"
// import photo2 from "../../../Images/TeamPhoto/photo2.webp"
// import photo3 from "../../../Images/TeamPhoto/photo3.jpg"
// import "./aboutUsSilder.css"

// const images = [
//     photo1,
//     photo2,
//     photo3
// ];



// const AutoSlider = () => {
//     const settings = {
//       dots: false,
//       infinite: true,
//       speed: 1000,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       initialSlide: 0,
//       autoplay: true,
//       autoplaySpeed: 3000, // Change slide every 3 seconds
//       arrows: true, // Hide arrows if not needed'
//       className: "myCustomCarousels",
//       responsive: [
//         {
//             breakpoint: 1024,
//             settings: {
//               slidesToShow: 1,
//               slidesToScroll:   1,
//               arrows:true
//             //   infinite: true,
//             //   dots: true
//             }
//           },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           initialSlide: 1,
//           arrows:true
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows:true
//         }
//       }
//     ]
//     };
  
//     return (
//       <Box sx={{ maxWidth: "100%"}}>
//         <Slider {...settings}>
//           {images.map((img, index) => (
//             <Box key={index}  >  
//             <img
//               src={img}
//               alt={`Slide ${index + 1}`}
//               style={{ width: "100%",height:"88vh",  }}
//             />
//           </Box>
//           ))}
//         </Slider>
//       </Box>
//     );
//   };



// export default AutoSlider;


import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import director from "../../../Images/Partner/director.jpg"
// import president from "../../../Images/Partner/president.jpg"
// import co_founder from "../../../Images/Partner/co-founder.jpg"
// import hpm from "../../../Images/Partner/hpm.png"

import './contactSilder.css'; 

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { Avatar, Box, Paper, Typography } from '@mui/material';
import { commonCss } from '../../../CssStyle/commonCss';

export default function AutoSlider() {
  const partnerList=[
    {
      image:"/Images/Partner/president.jpg",
      name:"Rhonda B.",
      position:" President ",
      Description:"“ They elevated our strategy well beyond our initial expectations with remarkable expertise.” "
    },
    {
      image:"/Images/Partner/director.jpg",
      name:"Lin J.",
      position:"Director, Strategies",
      Description:"“ Quality was never compromised, yet they beat our expectations on timing. ” "
    },
    {
      image:"/Images/Partner/co-founder.jpg",
      name:"Nelson W.",
      position:" Co-founder ",
      Description:"“ They understand our needs quickly, making collaboration smooth and efficient. ”  "
    },
    {
      image:"/Images/Partner/hpm.png",
      name:"Han C.",
      position:" Head, Project Management ",
      Description:"“ Working with them is effortless thanks to their professionalism and organized mindset. ”  "
    },
  ]
  return (
    <>
      <Swiper
        spaceBetween={20}
        // centeredSlides={true}
        slidesPerView={3}
        // loop={true}
        // autoplay={{
        //   delay: 2500,
        //   disableOnInteraction: false,
        // }}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          968: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        }}
        grabCursor={true}
        // navigation={true}
        modules={[Pagination]}
        className="mySwiperPartner"
      >
        {partnerList.map((list,i)=>(
 <SwiperSlide style={{height:"fit-content",padding:"1rem",background:"transparent"}} key={i} >
 <Paper elevation={4} sx={{display:"flex",flexDirection:"column",alignItems:"center",gap:"1rem",p:"1rem",width:"100%",height:"100%",borderRadius:"20px"}}>
 <Avatar alt={list.name} src={list.image} sx={{ width: 120, height: 120 }}/>
 <Typography variant='h5' sx={{fontSize:"24px",color:commonCss.orange,textAlign:"center",fontFamily:'"Roboto", sans-serif'}}>{list.name}</Typography>
 <Typography variant='h5' sx={{color:commonCss.gray,textAlign:"center",fontWeight:200,fontSize:"1.2rem",fontFamily:'"Roboto", sans-serif'}}> {list.position} </Typography>
 <Typography variant='body1' sx={{color:commonCss.darkGray,fontSize:"18px",textAlign:"center",fontFamily:'"Roboto", sans-serif'}}> {list.Description} </Typography>
 </Paper>
 
 </SwiperSlide>
        ))}
       
         
      </Swiper>
    </>
  );
}